import { render, staticRenderFns } from "./RefundRecordItem.vue?vue&type=template&id=3a821832&scoped=true"
import script from "./RefundRecordItem.vue?vue&type=script&lang=js"
export * from "./RefundRecordItem.vue?vue&type=script&lang=js"
import style0 from "./RefundRecordItem.vue?vue&type=style&index=0&id=3a821832&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a821832",
  null
  
)

export default component.exports